module.exports = __webpack_public_path__ + "img/nearby.png.dd43af04.webp";